'use strict';

const _ = require('lodash');
const util = require('_core_ext/util');
const componentContainer = document.querySelector('.js-store-reference-container');
let storeIdInput;
let storeNameInput;
let storesListContainer;
let storesList;
let storeInputError;

if (componentContainer) {
    storeIdInput = componentContainer.querySelector('.js-store-id-input');
    storeNameInput = componentContainer.querySelector('.js-store-reference-input');
    storesListContainer = componentContainer.querySelector('.js-stores-container');
    storesList = storesListContainer.querySelector('ul');
    storeInputError = componentContainer.querySelector('.js-store-error');
}


const handleStoreInput = (e) => {
    if (e.target.value.length < 2) {
        storesList.innerHTML = '';
        storesListContainer.classList.add('hidden');
        return;
    }
    const url = util.appendParamsToUrl(Urls.getStoresByTitle, {
        partName: e.target.value
    });

    fetch(url)
        .then(res => {
            if (!res.ok) {
                return Promise.reject(new Error (res.statusText));
            }
            return res.text();
        })
        .then(data => {
            if (data.trim()) {
                storesList.innerHTML = data;
                storesListContainer.classList.remove('hidden');
            } else {
                storesListContainer.classList.add('hidden');
                storesList.innerHTML = '';
            }
        })
        .catch(e => console.log('error', e));
};

const validateStore = async () => {
    if (!storeNameInput.value) {
        storeIdInput.value = '';
        storeInputError.classList.add('hidden');
        componentContainer.setAttribute('data-store-checked', 1);
        return true;
    }
    const url = util.appendParamsToUrl(Urls.getStoresByTitle, {
        fullName: storeNameInput.value
    });

    const isStoreValid = await fetch(url)
            .then(res => {
                if (!res.ok) {
                    return Promise.reject(new Error (res.statusText));
                }
                return res.json();
            })
            .then(data => {
                const storeID = data.storeId;
                if (storeID) {
                    storeIdInput.value = storeID;
                    storeInputError.classList.add('hidden');
                    componentContainer.setAttribute('data-store-checked', 1);
                    return true;
                } else {
                    storeIdInput.value = '';
                    storeInputError.classList.remove('hidden');
                    componentContainer.setAttribute('data-store-checked', 1);
                    return false;
                }
            })
            .catch(e => console.log('error', e))
            .finally(() => {
                $(storeNameInput).trigger('focusout');
                storesListContainer.classList.add('hidden');
            });
    return isStoreValid;
};

const initEvents = () => {

    if (storeNameInput) {
        storeNameInput.addEventListener('input', _.debounce(e => handleStoreInput(e), 150));

        document.addEventListener('click', e => {
            if (e.composedPath().includes(storesListContainer)) {
                const storeName = e.target.getAttribute('data-store-name') || e.target.parentElement.getAttribute('data-store-name');
                const storeID = e.target.getAttribute('data-store-id') || e.target.parentElement.getAttribute('data-store-id');
                if (storeName && storeID) {
                    storeNameInput.value = storeName;
                    storeIdInput.value = storeID;
                    storesListContainer.classList.add('hidden');
                    storesList.innerHTML = '';
                    storeInputError.classList.add('hidden');
                    componentContainer.setAttribute('data-store-checked', 1);
                }
            } else if (e.composedPath().includes(storeNameInput)) {
                componentContainer.setAttribute('data-store-checked', 0);
                if (storesList.hasChildNodes()) {
                    storesListContainer.classList.remove('hidden');
                }
            } else if (!Number(componentContainer.getAttribute('data-store-checked'))) {
                validateStore();
                storesListContainer.classList.add('hidden');
            }
        });
    }

};

module.exports = {
    init: function () {
        initEvents();
    }
};